import { lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from '../App';
import { NotFound } from '../pages';
import { routes, subRoutes } from './routes';

const Authorization = lazy(
  () => import('@pages/notAuthenticated/Authorization'),
);

const Consumption = lazy(() => import('@pages/authenticated/Consumption'));
const DeliveryPoints = lazy(
  () => import('@pages/authenticated/DeliveryPoints'),
);
const Invoices = lazy(() => import('@pages/authenticated/Invoices'));
const Reports = lazy(() => import('@pages/authenticated/Reports'));
const TabsOwnInformation = lazy(
  () => import('@pages/authenticated/OwnInformation/TabsOwnInformation'),
);
const ContactUs = lazy(() => import('@pages/authenticated/ContactUs'));

const AccessibilityStatementEN = lazy(() =>
  import(
    '@pages/notAuthenticated/AccessibilityStatement/AccessibilityStatementEN'
  ).then(module => ({
    default: module.AccessibilityStatementEN,
  })),
);

const AccessibilityStatementFI = lazy(() =>
  import(
    '@pages/notAuthenticated/AccessibilityStatement/AccessibilityStatementFI'
  ).then(module => ({
    default: module.AccessibilityStatementFI,
  })),
);

const AccessibilityStatementSV = lazy(() =>
  import(
    '@pages/notAuthenticated/AccessibilityStatement/AccessibilityStatementSV'
  ).then(module => ({
    default: module.AccessibilityStatementSV,
  })),
);

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={routes.index} element={<App />}>
          <Route path={subRoutes.consumption} element={<Consumption />} />
          <Route
            path={subRoutes.consumptionSites}
            element={<DeliveryPoints />}
          />
          <Route path={subRoutes.invoices} element={<Invoices />} />
          <Route path={subRoutes.reports} element={<Reports />} />
          <Route
            path={subRoutes.ownInformation}
            element={<TabsOwnInformation />}
          />
          <Route path={subRoutes.contactUs} element={<ContactUs />} />
        </Route>
        <Route path={routes.authorization} element={<Authorization />} />
        <Route
          path={routes.accessibilityStatementEn}
          element={<AccessibilityStatementEN />}
        />
        <Route
          path={routes.accessibilityStatementFi}
          element={<AccessibilityStatementFI />}
        />
        <Route
          path={routes.accessibilityStatementSv}
          element={<AccessibilityStatementSV />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
